<template>
  <div class="usuarios-medicinales-container">
    <h1 class="titulo">Administración de Usuarios Medicinales</h1>
    <div class="botones-acciones">
      <button class="btn btn-listar" @click="mostrarLista"><font-awesome-icon :icon="['fas', 'list']" /> Listar Usuarios</button>
      <button class="btn btn-alta" @click="mostrarFormularioAltaHandler"><font-awesome-icon :icon="['fas', 'user-plus']" /> Alta Usuario</button>
    </div>
    <ListaUsuariosMedicinales v-if="!mostrarFormulario && !mostrarDetalles && !mostrarFormularioAlta" @editar="editarUsuario" @verDetalles="verDetalles" />
    <FormularioUsuarioMedicinal 
      v-if="mostrarFormulario" 
      :usuarioId="usuarioId" 
      @volver="volverALaLista" 
      @usuarioActualizado="volverALaLista" 
      @usuarioCreado="volverALaLista" 
      @cancelar="volverALaLista" 
    />
    <DetalleUsuarioMedicinal v-if="mostrarDetalles" :usuarioId="usuarioId" @volver="volverALaLista" />
    <FormularioUsuarioMedicinal v-if="mostrarFormularioAlta" @usuarioCreado="volverALaLista" @usuarioActualizado="volverALaLista" @cancelar="volverALaLista" />
  </div>
</template>

<script>
import { ref } from 'vue';
import ListaUsuariosMedicinales from '@/components/UsuariosMedicinales/ListaUsuariosMedicinales.vue';
import FormularioUsuarioMedicinal from '@/components/UsuariosMedicinales/FormularioUsuarioMedicinal.vue';
import DetalleUsuarioMedicinal from '@/components/UsuariosMedicinales/DetalleUsuarioMedicinal.vue';

export default {
  components: {
    ListaUsuariosMedicinales,
    FormularioUsuarioMedicinal,
    DetalleUsuarioMedicinal
  },
  setup() {
    const mostrarFormulario = ref(false);
    const mostrarDetalles = ref(false);
    const mostrarFormularioAlta = ref(false);
    const usuarioId = ref(null);
    const usuarioParaEditar = ref(null);
    const usuarioParaDetalles = ref(null);

    const editarUsuario = (usuario) => {
      usuarioId.value = usuario.id;
      mostrarFormulario.value = true;
      usuarioParaEditar.value = usuario;
    };

    const verDetalles = (usuario) => {
      usuarioId.value = usuario.id;
      mostrarDetalles.value = true;
      usuarioParaDetalles.value = usuario;
    };

    const volverALaLista = () => {
      mostrarFormulario.value = false;
      mostrarDetalles.value = false;
      mostrarFormularioAlta.value = false;
      usuarioId.value = null;
    };

    const mostrarFormularioAltaHandler = () => {
      mostrarFormulario.value = false;
      mostrarDetalles.value = false;
      mostrarFormularioAlta.value = true;
    };

    const mostrarLista = () => {
      mostrarFormulario.value = false;
      mostrarDetalles.value = false;
      mostrarFormularioAlta.value = false;
    };

    mostrarLista(); // Llamar a mostrarLista al inicio para mostrar la lista por defecto

    return {
      mostrarFormulario,
      mostrarDetalles,
      mostrarFormularioAlta,
      usuarioId,
      usuarioParaEditar,
      usuarioParaDetalles,
      editarUsuario,
      verDetalles,
      volverALaLista,
      mostrarFormularioAltaHandler,
      mostrarLista
    };
  }
};
</script>

<style scoped>
.usuarios-medicinales-container {
  padding: 20px;
  width: 100%;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.titulo {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.botones-acciones {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}

.btn {
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-listar {
  background-color: #4a7d3a;
  color: white;
}

.btn-listar:hover {
  background-color: #3b6230;
}

.btn-alta {
  background-color: #4fbfbe;
  color: white;
}

.btn-alta:hover {
  background-color: #3f9999;
}
</style> 